const singleColumn = () => {
  const index = document.querySelector('.p-blog-detail-index');
  const indexHeader = document.querySelector('.p-blog-detail-index__header');
  const indexBody = document.querySelector('.p-blog-detail-index__body');
  const entry = document.querySelector('.p-blog-detail__entry');
  const footer = document.querySelector('.p-blog-detail__footer');
  const prevNextPosts = document.querySelector('.vk_posts.next-prev');

  /**
   * 目次の展開
   */
  indexHeader.addEventListener('click', () => {
    $(indexBody).slideToggle();
  });

  /**
   * 目次の生成
   */
  const entryList = entry.querySelectorAll('h2, h3, h4');
  if (entryList.length) {
    entryList.forEach((entry, index) => {
      let entryId = entry.id;
      if (entryId == '') {
        entryId = `entry-${index}`;
        entry.setAttribute('id', entryId);
      }
      const entryLink = document.createElement('a');
      entryLink.setAttribute('href', `#${entryId}`);
      if (entry.tagName === 'H2') {
        entryLink.setAttribute('data-index', '1');
      } else if (entry.tagName === 'H3') {
        entryLink.setAttribute('data-index', '2');
      } else if (entry.tagName === 'H4') {
        entryLink.setAttribute('data-index', '3');
      }
      entryLink.textContent = entry.textContent;
      indexBody.appendChild(entryLink);
    });
  }

  /**
   * 前後の記事（prevNextPosts）を(footer)内へ移動させる
   */
  if (prevNextPosts) {
    footer.appendChild(prevNextPosts);
  }

  /**
   *
   */
  const breadItems = document.querySelectorAll('.breadcrumb-list__item');
  const homeUrl = document.querySelector('body').dataset.homeUrl;
  if (breadItems.length > 0) {
    breadItems.forEach((item) => {
      const child = item.querySelector('a, span');
      if (child.innerText === '塗装のあれこれ') {
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'blog/');
        aTag.innerText = '塗装のあれこれ';
        item.innerHTML = '';
        item.appendChild(aTag);
      }
    });
  }
};

export default singleColumn;
